import { LoggerService } from "@Front/Services/LoggerService/LoggerService";

const FOLDER_LIST_PATHS = ["/folders", "/folders/shared", "/folders/archived", "/folders/deleted", "/folders/create", "/folders/select"];

export function resolveFolderOfficeChangeRedirect(): string | null {
	if (typeof window === "undefined") {
		return null;
	}
	const currentPath = window.location.pathname;
	const isOnFolderDetailPage = currentPath.match(/^\/folders\/[^/]+/);
	const isOnListPage = FOLDER_LIST_PATHS.includes(currentPath);

	if (!isOnFolderDetailPage || isOnListPage) {
		return null;
	}

	if (currentPath.includes("/folders/archived/")) {
		LoggerService.info("🔄 Redirection changement office (archived)", { redirectTo: "/folders/archived" });
		return "/folders/archived";
	}
	if (currentPath.includes("/folders/deleted/")) {
		LoggerService.info("🔄 Redirection changement office (deleted)", { redirectTo: "/folders/deleted" });
		return "/folders/deleted";
	}
	LoggerService.info("🔄 Redirection changement office vers /folders");
	return "/folders";
}

export function replaceLocationOrReload(redirectTo: string | null): void {
	if (redirectTo) {
		LoggerService.info("🔄 Redirection après changement office", { redirectTo });
		window.location.replace(redirectTo);
		return;
	}
	LoggerService.info("🔄 Rechargement de la page actuelle après changement office");
	window.location.reload();
}
